import type { FunctionComponent } from 'react';
import { ButtonBack, ButtonNext } from 'pure-react-carousel';
import styled, { css } from 'styled-components';
import {
  mediaHelper,
  ArrowLeftLg,
  ArrowRightLg,
  paletteHelper,
  spacingHelper,
  boxShadow,
} from '@property.com.au/ui-kit';
import { useMediaGalleryLightBoxContext } from '../../../../contexts/MediaGalleryLightBoxContext/MediaGalleryLightBoxContext';
import { useTouchScreen } from '../../../../../hooks/useTouchScreen';

const controlSize = 48;

const NavigationButtonStyles = css`
  background: ${paletteHelper('backgroundPrimaryLow')};
  height: ${controlSize}px;
  width: ${controlSize}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  transition: 0.2s;
  &:hover {
    background: ${paletteHelper('backgroundPrimaryBase')};
  }
  &:active {
    ${boxShadow.defaultBoxShadow}
  }
`;

const Back = styled(ButtonBack)<{ $isTouchDevice: boolean }>`
  ${NavigationButtonStyles};
  left: calc((${controlSize}px + ${spacingHelper('extraLarge')}) * -1);
  ${mediaHelper('mobile')} {
    left: ${spacingHelper('extraSmall')};
    ${(props) => props.$isTouchDevice && 'display: none'}
  }
  ${mediaHelper('tablet')} {
    left: ${spacingHelper('extraLarge')};
    ${(props) => props.$isTouchDevice && 'display: none'}
  }
`;

const Next = styled(ButtonNext)<{ $isTouchDevice: boolean }>`
  ${NavigationButtonStyles};
  right: calc((${controlSize}px + ${spacingHelper('extraLarge')}) * -1);
  ${mediaHelper('mobile')} {
    right: ${spacingHelper('extraSmall')};
    ${(props) => props.$isTouchDevice && 'display: none;'}
  }
  ${mediaHelper('tablet')} {
    right: ${spacingHelper('extraLarge')};
    ${(props) => props.$isTouchDevice && 'display: none;'}
  }
`;

export const MediaNavigationButton: FunctionComponent = () => {
  const { isSupported } = useTouchScreen();
  const { enableAnimation, currentSlideIndex, totalSlidesCount } = useMediaGalleryLightBoxContext();

  const isFirstSlide = currentSlideIndex === 0;
  const isLastSlide = currentSlideIndex === totalSlidesCount - 1;

  return (
    <>
      {!isFirstSlide && (
        <Back onClick={() => enableAnimation} $isTouchDevice={isSupported}>
          <ArrowLeftLg>Back</ArrowLeftLg>
        </Back>
      )}
      {!isLastSlide && (
        <Next onClick={() => enableAnimation} $isTouchDevice={isSupported}>
          <ArrowRightLg>Next</ArrowRightLg>
        </Next>
      )}
    </>
  );
};
